import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// 引入animate动画库和wowjs实现滚动实时动画特效
import "animate.css";
import "wowjs/css/libs/animate.css";
import wow from "wowjs";
Vue.prototype.$wow = wow;

// 引入bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);

//引入初始化样式
import "./assets/css/style.css";
import "./assets/css/default.css";
import "./assets/css/responsive.css";
import "./assets/css/fontawesome-all.min.css";

// vue-mate
import Meta from 'vue-meta';
Vue.use(Meta);

// 混入代码引入
import mixin from "./assets/mixin/mixin";
Vue.mixin(mixin);

import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  metaInfo() {
    return {
      title: this.$store.state.metaModule.metaInfo.title,
      meta: [
        {
          name: "keywords",
          content: this.$store.state.metaModule.metaInfo.keywords
        }, {
          name: "description",
          content: this.$store.state.metaModule.metaInfo.description
        }
      ]
    }
  },
  render: (h) => h(App),
}).$mount("#app");
